<!-- =============================================================================================================================================== -->
<!-- ================================================================== NO FORMATEAR =============================================================== -->
<!-- =============================================================================================================================================== -->

<div class="card">
    <!-- <p-toast /> -->
    <p-confirmPopup key="DT"></p-confirmPopup>
    <p-table #dt1 [value]="dataTable" dataKey="codeinterno" [tableStyle]="{ 'min-width': '60rem' }"
        [expandedRowKeys]="expandedRows" styleClass="border-1 border-200" [columns]="metadataTable"
        [editMode]="editMode" size="small" [rows]="rows[0]" [paginator]="footer" [rowsPerPageOptions]="rows"
        [scrollHeight]="scrollHeight" (onFilter)="onTableFilter($event)" [scrollable]="true">

        <!-- =============================================================================================================================================== -->
        <!-- ================================================================= CAPTION PADRE =============================================================== -->
        <!-- =============================================================================================================================================== -->

        <ng-template #caption>

            <div class="flex flex-wrap justify-end gap-2">

                <p-button icon="pi pi-plus" text (onClick)="expandAll()" variant="outlined" size="small"
                    pTooltip="Expandir todo" />

                <p-button icon="pi pi-minus" text (onClick)="collapseAll()" variant="outlined" size="small"
                    pTooltip="Contraer todo" />

                <!-- #region BORRAR TODOS LOS FILTROS -->

                <p-button icon="pi pi-filter-slash" pTooltip="Quitar filtros" severity="info" aria-label="Save"
                    (onClick)="table.reset()" size="small" (onClick)="onTableFilter($event)"
                    *ngIf="btnResetFiltros"></p-button>

                <!-- #endregion -->

                <!-- #region EXPORTAR A EXCEL -->

                <p-button icon="pi pi-file-excel" pTooltip="Exportar a Excel" severity="success" aria-label="Exportar"
                    (onClick)="export()" size="small" *ngIf="exportDataCsv"></p-button>

                <!-- #endregion -->

                <ng-container *ngIf="buttonCaption.length !== 0">
                    <p-button *ngFor="let item of buttonCaption" [icon]="item.icon" [label]="item.label"
                        [variant]="item.variant" [severity]="item.severity" (onClick)="item.function()" size="small"
                        class="caption" [pTooltip]="item.pTooltip"></p-button>
                </ng-container>

                <p-button *ngIf="addRowFather" icon="pi pi-plus" (onClick)="addEmptyRow()" severity="success"
                    size="small" pTooltip="Nuevo"></p-button>

                <p-button icon="pi pi-database" (onClick)="viewInfo()" size="small"></p-button>

                <ng-container *ngIf="optionTable?.father?.caption as opciones">

                    <p-button *ngIf="opciones?.addRow" icon="pi pi-plus" (onClick)="addEmptyRow()" severity="success"
                        size="small" pTooltip="Nuevo"></p-button>

                    <!-- <p-button *ngIf="opciones?.deleteSelectRow" icon="pi pi-trash" pTooltip="Eliminar seleccionados"
                        severity="danger" (onClick)="deleteCheckList(rowData)" size="small"></p-button> -->

                    <p-button *ngFor="let item of opciones?.buttons" [icon]="item.icon" [label]="item.label"
                        [variant]="item.variant" [severity]="item.severity" (onClick)="item.function()" size="small"
                        class="caption" [pTooltip]="item.pTooltip"></p-button>

                </ng-container>

                <div class="leyendas-container flex align-items-center ml-auto">
                    <ng-container *ngFor="let leyenda of customLeyendasHex">
                        <div class="leyenda-item flex align-items-center ml-4">
                            <div class="leyenda-color-circle mr-1" [style.background]="leyenda.color"></div>
                            <span class="text-500" style="font-size: 10px;">{{ leyenda.texto }}</span>
                        </div>
                    </ng-container>
                </div>
            </div>

            @if(showFilters && ( (cadenaFiltrosConsolidada() != '' && cadenaFiltrosConsolidada() != null) ||
            cadenaFiltrosHijo())){
            <div class="filter-summary-container p-mt-2">
                <div class="filter-summary-content">
                    <span class="filter-title">
                        <i class="pi pi-filter"></i>
                    </span>

                    <span class="filter-text">

                        @if(cadenaFiltrosConsolidada() && cadenaFiltrosHijo()){
                        <span class="text-primary font-bold">PADRE: </span>
                        <span [innerHTML]="cadenaFiltrosConsolidada()"></span>
                        <span class="mx-2">|</span>
                        <span class="text-orange-500 font-bold">HIJO: </span>
                        <span [innerHTML]="cadenaFiltrosHijo()"></span>
                        }
                        @else if(!cadenaFiltrosConsolidada() && cadenaFiltrosHijo()){
                        <span class="text-orange-500 font-bold">HIJO: </span>
                        <span [innerHTML]="cadenaFiltrosHijo()"></span>
                        }
                        @else {
                        <span [innerHTML]="cadenaFiltrosConsolidada()"></span>
                        }

                    </span>
                </div>
            </div>
            }

        </ng-template>

        <!-- =============================================================================================================================================== -->
        <!-- ============================================================= FIN CAPTION PADRE =============================================================== -->
        <!-- =============================================================================================================================================== -->

        <!-- =============================================================================================================================================== -->
        <!-- ================================================================= HEADER PADRE =============================================================== -->
        <!-- =============================================================================================================================================== -->

        <ng-template #header let-columns>

            <tr class="bg-blue-50">

                <th class="header-table color-tree-01">
                    <p-checkbox binary="true" [(ngModel)]="checkAllStateFather" *ngIf="viewCheck"
                        (onChange)="checkAll($event, null, 'Father')" size="small"></p-checkbox>
                </th>

                <th *ngFor="let col of columns" class="header-table color-tree-01" [ngClass]="{ 'hidden': col.visible }"
                    [ngStyle]="col.styleColumn">
                    {{ col.header.title }}
                    <p-button icon="pi pi-save" class="add-button" *ngIf="col.type == 'checkList'" size="small"
                        [disabled]="!checkLists?.[col.field.output] ||checkLists?.[col.field.output]?.length === 0"
                        (click)="col?.function?.(checkLists?.[col.field.output])"></p-button>
                    <p-sortIcon [pSortableColumn]="col.field.output" [field]="col.field.output"
                        *ngIf="col.type != 'checkList'" />
                    <p-columnFilter type="text" [field]="col.field.output" display="menu" matchMode="contains"
                        *ngIf="col.type != 'checkList'" />
                </th>

                <th class="header-table color-tree-01" *ngIf="editModeFather==='row'"></th>

            </tr>

        </ng-template>

        <!-- =============================================================================================================================================== -->
        <!-- =============================================================== FIN HEADER PADRE ============================================================== -->
        <!-- =============================================================================================================================================== -->

        <!-- =============================================================================================================================================== -->
        <!-- ================================================================== BODY PADRE ================================================================= -->
        <!-- =============================================================================================================================================== -->

        <ng-template #body let-rowData let-columns="columns" let-editing="editing" let-ri="rowIndex"
            let-expanded="expanded">

            <tr [pEditableRow]="rowData" *ngIf="rowData.statustable !== 'D'"
                [ngStyle]="styleRow(rowData) ? styleRow(rowData) : null"
                [ngClass]="{'color-tree-02': !styleRow(rowData)}">

                <td>
                    <div class="flex align-items-center justify-content-center gap-2">

                        <p-checkbox binary="true" [(ngModel)]="rowData.checked" size="small" *ngIf="viewCheck"
                            (onChange)="onChangeListCheck()"></p-checkbox>

                        <p-button [pRowToggler]="rowData"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" size="small"
                            [pTooltip]="expanded ? 'Contraer' : 'Expandir'" />

                        <ng-container *ngFor="let item of funcionalButtonsFather">
                            <p-button [icon]="item.icon" (onClick)="item.function?.(rowData)" [severity]="item.severity"
                                size="small" [pTooltip]="item.pTooltip"
                                [disabled]="(item.validateChanges ? validateRowChanges(rowData) : item.disabled ? item.disabled?.(rowData) : false)"
                                *ngIf="item.visible?.(rowData) ?? true"></p-button>
                        </ng-container>

                        <ng-container *ngIf="optionTable?.father?.body as opciones">

                            <ng-container *ngFor="let item of opciones.buttons">
                                <p-button [icon]="item.icon" (onClick)="item.functionRow?.(rowData)"
                                    [severity]="item.severity" size="small" [pTooltip]="item.pTooltip"
                                    [disabled]="(item.validateChanges ? validateRowChanges(rowData) : item.disabled ? item.disabled?.(rowData) : false)"></p-button>
                            </ng-container>

                        </ng-container>

                    </div>
                </td>

                <ng-container *ngIf="editModeFather==='row' || editModeFather==='' ">
                    <td *ngFor="let col of columns"
                        [ngStyle]="col?.dynamicStyleColumn ? col.dynamicStyleColumn(rowData) : col?.styleColumn">
                        <p-cellEditor>
                            <ng-template #input>

                                <ng-container *ngIf="col.type === 'text' ">
                                    <input pInputText type="text" [(ngModel)]="rowData[col.field.input]"
                                        pSize="small" />
                                </ng-container>

                                <ng-container *ngIf="col.type === 'date'">
                                    <p-datePicker #dpFather [(ngModel)]="rowData[col.field.input]" dateFormat="dd/mm/yy"
                                        [id]="'dpFather'+ri+col.field.input" size="small"
                                        inputStyleClass="w-full text-xs" appendTo="body"
                                        (ngModelChange)="col.onChanges?.({'row': rowData, 'event': $event, 'id': 'dpFather'+ri+col.field.input, 'datePicker': dpFather})"></p-datePicker>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'datetime'">
                                    <p-datePicker [(ngModel)]="rowData[col.field.input]" [showTime]="true"
                                        appendTo="body" size="small"></p-datePicker>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'checkbox'">
                                    <div class="align-control">
                                        <p-checkbox [(ngModel)]="rowData[col.field.input]" size="small" binary="true" />
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'select'">
                                    <p-select [options]="col.itemSelect" [(ngModel)]="rowData[col.field.input]"
                                        showClear="true" filter="true" appendTo="body" virtualScroll="true"
                                        class="w-12rem text-xs" styleClass="text-xs" size="small"
                                        virtualScrollItemSize="20" [panelStyle]="{ 'min-width': '500px' }"
                                        (onChange)="onChangeSelect($event, rowData, col.itemSelect, col.field.output)" />
                                    <!-- class="w-12rem" -->
                                </ng-container>

                                <ng-container *ngIf="col.type === 'button'">
                                    <ng-container *ngFor="let btn of col.button">
                                        <p-button [icon]="btn.icon" (onClick)="btn.functionRow?.(rowData)" size="small"
                                            [pTooltip]="btn.pTooltip" [disabled]="btn.disabled?.(rowData)">
                                        </p-button>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="col.type === 'checkList'">
                                    <div class="align-control">
                                        <p-checkbox [(ngModel)]="rowData[col.field.input]" [binary]="true"
                                            inputId="binary" [disabled]="rowData[col.validar] === true"
                                            (onChange)="onChangeCheckList($event, rowData, col)"
                                            [pTooltip]="col.pTooltip(rowData)" [escape]="false">
                                        </p-checkbox>
                                    </div>
                                </ng-container>

                                <div class="w-auto"
                                    *ngIf="col.type === 'selectEdit' && rowData[col.modoOutput] === true">
                                    <p-select [(ngModel)]="rowData[col.field.output]" [options]="col.itemSelect"
                                        appendTo="body" placeholder="Nombre" styleClass="w-full" [filter]="true"
                                        [showClear]="true" optionLabel="label" class="w-12rem"
                                        [panelStyle]="{ 'min-width': '500px' }"
                                        [disabled]="getDisabledSelectEdit(rowData?.[col.condicion],rowData?.[col.descCondicion])"
                                        [virtualScroll]="col.virtualScroll" [readonly]="col.inputStatus === 'lock'">
                                    </p-select>
                                </div>

                            </ng-template>
                            <ng-template #output>
                                <div style="font-size: 11px;">
                                    <!-- <ng-container *ngIf="col.type === 'text' || col.type === 'select'">
                                        {{rowData[col.field.output]}}
                                    </ng-container> -->
                                    <ng-container *ngIf="col.type === 'text' || col.type === 'select'">
                                        <div [ngStyle]="{
                                            'width': col.width ? col.width : 'auto',
                                            'max-width': col.maxWidth ? col.maxWidth : 'none',
                                            'overflow': col.maxWidth ? 'hidden' : 'visible',
                                            'text-overflow': col.maxWidth ? 'ellipsis' : 'clip',
                                            'white-space': col.maxWidth ? 'nowrap' : 'normal'
                                        }" [title]="rowData[col.field.output]"> {{ rowData[col.field.output] }}
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'int'">
                                        {{ formatNumber(rowData[col.field.output], 'int')}}
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'date' || col.type === 'datetime'">
                                        {{ rowData[col.field.output] ? util.formatearfecha(rowData[col.field.output],
                                        'dd/mm/yyyy') : null}}
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'checkbox'">
                                        <div class="align-control">
                                            <p-checkbox [(ngModel)]="rowData[col.field.output]" binary="true"
                                                [disabled]="true" />
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'decimal'">
                                        {{convertToDecimal(rowData[col.field.output])}}
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'porcentaje'">
                                        {{ formatPorcentaje(rowData[col.field.output], col.maxFractionDigits ?? 2) }}
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'button'">
                                        <ng-container *ngFor="let btn of col.button">
                                            <p-button [icon]="btn.icon" (onClick)="btn.functionRow?.(rowData)"
                                                size="small" [pTooltip]="btn.pTooltip"
                                                [disabled]="btn.disabled?.(rowData)">
                                            </p-button>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'checkList'">
                                        <div class="align-control">
                                            <p-checkbox [(ngModel)]="rowData[col.field.output]" [binary]="true"
                                                inputId="binary" [disabled]="rowData[col.validar] === true"
                                                (onChange)="onChangeCheckList($event, rowData, col)"
                                                [pTooltip]="col.pTooltip(rowData)" [escape]="false">
                                            </p-checkbox>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="col.type === 'input_save'">
                                        <div class="align-control">
                                            <input pInputText type="text" [(ngModel)]="rowData[col.field.output]"
                                                pSize="small" />
                                            <span style="padding: 0 .1rem"></span>
                                            <p-button icon="pi pi-save" size="small"
                                                (onClick)="functionClick(col,rowData)"></p-button>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="col.type === 'b-select'">
                                        <div class="align-control">
                                            <p-select [options]="col.itemSelect" [(ngModel)]="rowData[col.field.input]"
                                                showClear="true" filter="true" appendTo="body" virtualScroll="true"
                                                class="w-16rem text-xs" styleClass="text-xs" size="small"
                                                virtualScrollItemSize="20" [panelStyle]="{ 'min-width': '500px' }"
                                                (onChange)="col.onChange?.(rowData);onChangeSelect($event, rowData.codeinterno, col.itemSelect, col.field.output)" />
                                            <span style="padding: 0 .1rem"></span>
                                            <p-button *ngIf="col.buttonSave" icon="pi pi-save" size="small"
                                                (onClick)="col.buttonSave?.(rowData)"></p-button>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="col.type === 'b-datetime'">
                                        <div class="align-control">
                                            <p-datePicker [(ngModel)]="rowData[col.field.input]" appendTo="body"
                                                dateFormat="dd/mm/yy" size="small" [showTime]="true"
                                                class="w-8rem text-xs" inputStyleClass="w-full text-xs"
                                                styleClass="w-8rem" showButtonBar="true"
                                                clearButtonStyleClass="p-button-sm"></p-datePicker>
                                            <span style="padding: 0 .1rem"></span>
                                            <p-button icon="pi pi-save" size="small"
                                                (onClick)="col.buttonSave?.(rowData)"></p-button>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="col.type === 'area_save'">
                                        <div class="align-control">
                                            <textarea pInputText type="text" [(ngModel)]="rowData[col.field.output]"
                                                pTextarea pSize="small" [attr.maxlength]="col.maxLength" [rows]="2"
                                                [readonly]="col.readonly"></textarea>
                                            <span style="padding: 0 .1rem"></span>
                                            <p-button icon="pi pi-save" size="small"
                                                (onClick)="functionClick(col,rowData)"></p-button>
                                        </div>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="(col.type === 'selectEdit' && rowData[col.modoOutput] === false)">
                                        {{ rowData[col.field.output]?.label ? rowData[col.field.output].label :
                                        (rowData[col.field.output]
                                        ?
                                        rowData[col.field.output] : '') }}
                                    </ng-container>
                                    <div class="w-auto"
                                        *ngIf="col.type === 'selectEdit' && rowData[col.modoOutput] === true">
                                        <p-select [(ngModel)]="rowData[col.field.output]" [options]="col.itemSelect"
                                            appendTo="body" placeholder="Nombre" styleClass="w-full" [filter]="true"
                                            [showClear]="true" optionLabel="label"
                                            [panelStyle]="{ 'min-width': '500px' }"
                                            [disabled]="getDisabledSelectEdit(rowData?.[col.condicion],rowData?.[col.descCondicion])"
                                            [virtualScroll]="col.virtualScroll" [readonly]="col.inputStatus === 'lock'"
                                            class="w-16rem">
                                        </p-select>
                                    </div>
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td *ngIf="editModeFather==='row'">

                        <div class="flex items-center justify-center gap-2">

                            <p-button *ngIf="!editing" pInitEditableRow icon="pi pi-pencil"
                                (click)="onRowEditInit(rowData)" severity="warn" size="small"
                                pTooltip="Editar"></p-button>

                            <p-button *ngIf="editing" pSaveEditableRow icon="pi pi-check"
                                (click)="onRowEditSave(rowData)" severity="success" size="small"
                                pTooltip="Confirmar"></p-button>

                            <p-button *ngIf="editing" pCancelEditableRow icon="pi pi-times"
                                (click)="onRowEditCancel(rowData, ri)" severity="danger" size="small"
                                pTooltip="Cancelar"></p-button>

                        </div>

                    </td>

                </ng-container>

                <ng-container *ngIf="editModeFather==='cell'">

                    <td *ngFor="let col of columns" [pEditableColumn]="rowData[col.field]"
                        [pEditableColumnField]="col.field">
                        <p-cellEditor>

                            <!-- MODO INPUT -->

                            <ng-template #input>

                                <!-- TEXT -->
                                <ng-container *ngIf="col.type === 'text'">
                                    <input pInputText type="text" [(ngModel)]="rowData[col.field.input]" />
                                </ng-container>
                                <!-- FIN TEXT -->

                                <!-- FECHA -->
                                <ng-container *ngIf="col.type === 'date'">
                                    <p-datePicker [(ngModel)]="rowData[col.field.input]" appendTo="body"
                                        dateFormat="dd/mm/yy" showClear="true"></p-datePicker>
                                </ng-container>
                                <!-- FIN FECHA -->

                                <!-- NUMBER INT -->
                                <ng-container *ngIf="col.type === 'int'">
                                    {{rowData[col.field.output.replace('_value', '_tipomoneda')] ? "":
                                    (rowData[col.field.input.replace('_value', '_tipomoneda')] === "001" ? "S/. " : "$")
                                    }}
                                    <p-inputnumber [(ngModel)]="rowData[col.field.input]" mode="decimal"
                                        useGrouping="false" showButtons="true"
                                        (onInput)="onChangeInput($event, rowData.codeinterno)" />
                                </ng-container>
                                <!-- FIN NUMBER INT -->

                                <!-- NUMBER DECIMAL -->
                                <ng-container *ngIf="col.type === 'decimal'">
                                    {{rowData[col.field.output.replace('_value', '_tipomoneda')] ? "":
                                    (rowData[col.field.input.replace('_value', '_tipomoneda')] === "001" ? "S/. " : "$")
                                    }}
                                    <p-inputnumber [(ngModel)]="rowData[col.field.input]" mode="decimal"
                                        useGrouping="true" showButtons="true" minFractionDigits="2"
                                        (onInput)="onChangeInput($event, rowData.codeinterno)" />
                                </ng-container>
                                <!-- FIN NUMBER DECIMAL -->

                                <!-- DROPDOWN -->
                                <ng-container *ngIf="col.type === 'select'">
                                    <p-select [options]="col.itemSelect" [(ngModel)]="rowData[col.field.input]"
                                        showClear="true" filter="true" appendTo="body" virtualScroll="true"
                                        class="w-12rem"
                                        (onChange)="onChangeSelect($event, rowData.codeinterno, col.itemSelect, col.field.output)" />
                                </ng-container>
                                <!-- FIN DROPDOWN -->

                            </ng-template>

                            <!-- FIN MODO INPUT -->

                            <!-- MODO OUTPUT -->

                            <ng-template #output>
                                <div style="text-align: center;">
                                    {{rowData[col.field.output.replace('_value', '_tipomoneda')] ?
                                    "":(rowData[col.field.input.replace('_value', '_tipomoneda')] === "001" ? "S/. " :
                                    "$") }}
                                    {{ rowData[col.field.output] }}
                                </div>
                            </ng-template>

                            <!-- FIN MODO OUTPUT -->

                        </p-cellEditor>
                    </td>
                </ng-container>

                <!-- FIN MODO EDICION TODAS LAS CELDAS -->

            </tr>
        </ng-template>

        <!-- =============================================================================================================================================== -->
        <!-- ================================================================ FIN BODY PADRE =============================================================== -->
        <!-- =============================================================================================================================================== -->

        <!-- =============================================================================================================================================== -->
        <!-- ============================================================== FOOTER PADRE ================================================================== -->
        <!-- =============================================================================================================================================== -->

        <ng-template #footer let-columns>
            <tr *ngIf="footerTotalFields.length">
                <td></td>
                <td *ngFor="let col of columns" [ngClass]="{ 'hidden': col.visible }">
                    {{ footerTotalFields.includes(col.field.output) ? getFooterTotal(col.field.output, col.type) : '' }}
                </td>
                <td *ngIf="editModeFather==='row'"></td>
            </tr>
        </ng-template>

        <!-- =============================================================================================================================================== -->
        <!-- ============================================================== FIN FOOTER PADRE =============================================================== -->
        <!-- =============================================================================================================================================== -->

        <ng-template #expandedrow let-rowData>
            <tr class="bg-blue-50">
                <td colspan="11">
                    <div class="p-2">

                        <!-- #region CHILDREN-->

                        <p-table [value]="rowData.detail" dataKey="id"
                            [columns]="rowData.metadata ?? metadataTableChildren" styleClass="border-1 border-200"
                            (onFilter)="onChildTableFilter($event)">

                            <ng-template #caption>

                                <div class="flex flex-wrap justify-end gap-2">

                                    <p-button icon="pi pi-database" (onClick)="viewInfo()" size="small"></p-button>

                                    <ng-container *ngIf="optionTable?.children?.caption as opciones">

                                        <p-button *ngIf="opciones?.addRow" icon="pi pi-plus"
                                            (onClick)="addEmptyChildrenRow(rowData)" severity="success" size="small"
                                            pTooltip="Nuevo"></p-button>

                                        <p-button *ngIf="opciones?.deleteSelectRow" icon="pi pi-trash"
                                            pTooltip="Eliminar seleccionados" severity="danger"
                                            (onClick)="deleteCheckList(rowData)" size="small"></p-button>

                                        <p-button *ngFor="let item of opciones?.buttons" [icon]="item.icon"
                                            [label]="item.label" [variant]="item.variant" [severity]="item.severity"
                                            (onClick)="item.functionRow(rowData)" size="small" class="caption"
                                            [pTooltip]="item.pTooltip"></p-button>

                                    </ng-container>

                                    <p-button *ngIf="addRowChildren" icon="pi pi-plus"
                                        (onClick)="addEmptyChildrenRow(rowData)" severity="success" size="small"
                                        pTooltip="Nuevo"></p-button>

                                    <p-button icon="pi pi-trash" pTooltip="Eliminar seleccionados" severity="danger"
                                        *ngIf="deleteRowChildren" (onClick)="deleteCheckList(rowData)"
                                        size="small"></p-button>

                                </div>

                            </ng-template>

                            <ng-template #header let-columns>
            <tr class="color-tree-03">
                <th class="first-th header-table color-tree-03">
                    <p-checkbox binary="true" [(ngModel)]="checkAllStateChildren[rowData.codeinterno]"
                        *ngIf="viewCheckChildren" (onChange)="checkAll($event, rowData, 'Children')"
                        size="small"></p-checkbox>
                    <!-- <p-checkbox binary="true" [(ngModel)]="checkAllState" (onChange)="checkAll($event)"
                        size="small"></p-checkbox> -->
                </th>
                <th *ngFor="let col of columns" class="header-table color-tree-03"
                    [ngClass]="{ 'hidden': col.visible }">
                    {{ col.header.title }}
                    <p-sortIcon [pSortableColumn]="col.field.output" [field]="col.field.output" />
                    <p-columnFilter type="text" [field]="col.field.output" display="menu" matchMode="contains" />

                    <ng-container *ngIf="col?.buttonsHeader">
                        <p-button *ngFor="let item of col?.buttonsHeader" [icon]="item.icon" [label]="item.label"
                            [variant]="item.variant" [severity]="item.severity" (onClick)="item.functionRow(rowData)"
                            size="small" [pTooltip]="item.pTooltip"></p-button>
                    </ng-container>

                </th>
            </tr>
        </ng-template>

        <ng-template #body let-rowChildren let-columns="columns">
            <tr [pEditableRow]="rowChildren" *ngIf="rowChildren.statustable !== 'D'">
                <!-- <td *ngFor="let item of columns" style="font-size: 11px;">
                    {{rowData[item.field.output]}}
                </td> -->

                <td>
                    <div class="first-th flex align-items-center justify-content-center gap-2">

                        <!-- <p-checkbox binary="true" [(ngModel)]="rowData.checked" size="small"
                            (onChange)="onChangeListCheck()"></p-checkbox> -->
                        <p-checkbox binary="true" [(ngModel)]="rowChildren.checked" size="small"
                            *ngIf="viewCheckChildren" (onChange)="onChangeListCheck()"></p-checkbox>

                        <p-button icon="pi pi-trash" severity="danger"
                            (onClick)="deleteChildrenRowByCode(rowData,rowChildren)" *ngIf="deleteRowChildren"
                            size="small"></p-button>

                        <ng-container *ngIf="optionTable?.children?.body as opciones">

                            <p-button *ngIf="opciones.deleteRow ?? opciones.deleteRowBy(rowData)" icon="pi pi-trash"
                                severity="danger" (onClick)="deleteChildrenRowByCode(rowData,rowChildren)"
                                size="small"></p-button>

                        </ng-container>

                        <ng-container *ngFor="let item of funcionalButtonsChildren">
                            <p-button [icon]="item.icon"
                                (onClick)="item.function?.({'father': rowData, 'children': rowChildren})"
                                [severity]="item.severity" size="small" [pTooltip]="item.pTooltip"
                                [disabled]="(item.validateChanges ? validateRowChanges(rowData) : item.disabled ? item.disabled?.(rowData) : false)"></p-button>
                        </ng-container>

                        <!-- <ng-container *ngFor="let item of funcionalButtons">
                            <p-button [icon]="item.icon" (onClick)="item.function(rowData)" [severity]="item.severity"
                                size="small" [pTooltip]="item.pTooltip"
                                [disabled]="item.disabled ? item.disabled(rowData) : false"></p-button>
                        </ng-container> -->

                    </div>
                </td>

                <!-- FIN ELEMENTOS FUNCIONALES DE LA TABLA -->

                <!-- <ng-container *ngTemplateOutlet="addBodyStart; context: { row: rowData }"></ng-container> -->

                <!-- #region MODO DE EDICION POR FILA -->

                <ng-container *ngIf="editModeChildren === 'row' || editModeChildren === ''">
                    <td *ngFor="let col of columns" [ngClass]="{ 'hidden': col.visible }"
                        [ngStyle]="col?.dynamicStyleColumn?.(rowChildren)">
                        <p-cellEditor>
                            <ng-template #input>
                                <input pInputText type="text" [(ngModel)]="rowChildren[col.field.input]" />
                            </ng-template>
                            <ng-template #output>

                                <div style="font-size: 11px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap; font-weight: 350;"
                                    [ngStyle]="col.styleColumn">
                                    <ng-container *ngIf="col.type === 'text'">
                                        {{rowChildren[col.field.output]}}
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'int'">
                                        {{ formatNumber(rowChildren[col.field.output], 'int')}}
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'decimal'">
                                        {{ convertToDecimal(rowChildren[col.field.output]) }}
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'porcentaje'">
                                        {{ formatPorcentaje(rowChildren[col.field.output], col.maxFractionDigits ?? 2) }}
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'date' || col.type === 'datetime'">
                                        {{ rowChildren[col.field.output] ?
                                        util.formatearfecha(rowChildren[col.field.output],
                                        'dd/mm/yyyy') : null}}
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'checkbox'">
                                        <div class="align-control">
                                            <p-checkbox [(ngModel)]="rowChildren[col.field.output]" size="small"
                                                binary="true" readonly="true" />
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="col.type === 'input_save'">
                                        <div class="align-control">
                                            <input pInputText type="text" [(ngModel)]="rowChildren[col.field.output]"
                                                pSize="small" />
                                            <p-button icon="pi pi-save" size="small" variant="outlined"
                                                (onClick)="functionClick(col,rowChildren)"></p-button>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                </ng-container>

                <!-- #endregion -->

                <!-- #region MODO EDICION TODAS LAS CELDAS -->

                <ng-container *ngIf="editModeChildren==='cell'">

                    <td *ngFor="let col of columns" [pEditableColumn]="rowChildren[col.field]"
                        [pEditableColumnField]="col.field" [ngClass]="{ 'hidden': col.visible }">
                        <p-cellEditor>

                            <!-- MODO INPUT -->

                            <ng-template #input>

                                <!-- TEXT -->
                                <ng-container *ngIf="col.type === 'text'">
                                    <input pInputText type="text" [(ngModel)]="rowChildren[col.field.input]"
                                        (input)="onChangeInput($event, rowChildren)" pSize="small" />
                                </ng-container>
                                <!-- FIN TEXT -->

                                <!-- FECHA -->
                                <ng-container *ngIf="col.type === 'date'">
                                    <p-datePicker [(ngModel)]="rowChildren[col.field.input]" appendTo="body"
                                        dateFormat="dd/mm/yy" showClear="true" size="small"
                                        styleClass="w-auto"></p-datePicker>
                                </ng-container>
                                <!-- FIN FECHA -->

                                <!-- NUMBER INT -->
                                <ng-container *ngIf="col.type === 'int'">
                                    <!-- {{rowData[col.field.output.replace('_value', '_tipomoneda')] ? "":
                                (rowData[col.field.input.replace('_value', '_tipomoneda')] === "001" ? "S/. " : "$ ") }} -->
                                    <p-inputnumber [(ngModel)]="rowChildren[col.field.input]" mode="decimal"
                                        useGrouping="false" showButtons="true"
                                        (onInput)="onChangeInput($event, rowChildren)" size="small" />
                                </ng-container>
                                <!-- FIN NUMBER INT -->

                                <!-- NUMBER DECIMAL -->
                                <ng-container *ngIf="col.type === 'decimal'">
                                    <!-- {{rowData[col.field.output.replace('_value', '_tipomoneda')] ? "":
                                (rowData[col.field.input.replace('_value', '_tipomoneda')] === "001" ? "S/. " : "$ ") }} -->
                                    <p-inputnumber [(ngModel)]="rowChildren[col.field.input]" mode="decimal"
                                        useGrouping="true" showButtons="true" minFractionDigits="2"
                                        (onInput)="onChangeInput($event, rowChildren)" size="small" />
                                </ng-container>
                                <!-- FIN NUMBER DECIMAL -->

                                <!-- DROPDOWN -->
                                <ng-container *ngIf="col.type === 'select'">
                                    <p-select [options]="col.itemSelect" [(ngModel)]="rowChildren[col.field.input]"
                                        showClear="true" filter="true" appendTo="body" virtualScroll="true"
                                        class="w-12rem text-xs" styleClass="text-xs"
                                        [panelStyle]="{ 'min-width': '500px' }"
                                        (onChange)="col.onChange?.({'father':rowData, 'children': rowChildren});onChangeSelect($event, rowChildren, col.itemSelect, col.field.output)"
                                        size="small" virtualScrollItemSize="20" />
                                    <!-- class="w-12rem" -->
                                </ng-container>

                                <ng-container *ngIf="col.type === 'selectByType'">
                                    <p-select
                                        [options]="listaSelectByType?.[rowData.codeinterno]?.[rowChildren.codeinterno] ?? []"
                                        [(ngModel)]="rowChildren[col.field.input]" showClear="true" filter="true"
                                        appendTo="body" virtualScroll="true" class="w-10rem text-xs"
                                        [panelStyle]="{ 'min-width': '500px' }" styleClass="text-xs"
                                        (onChange)="col.onChange?.(rowChildren);onChangeSelect($event, rowChildren, listaSelectByType?.[rowData.codeinterno]?.[rowChildren.codeinterno] ?? [], col.field.output)"
                                        size="small" virtualScrollItemSize="20" />
                                    <!-- class="w-12rem" -->
                                </ng-container>

                                <!-- FIN DROPDOWN -->

                                <!-- DROPDOWN -->
                                <ng-container *ngIf="col.type === 'moneda_monto'">
                                    <p-inputnumber [(ngModel)]="rowChildren[col.field.input]" mode="decimal"
                                        useGrouping="true" showButtons="false" minFractionDigits="2"
                                        (onBlur)="onChangeInput($event, rowChildren); col.function?.(rowChildren)"
                                        (keydown.enter)="onChangeInput($event, rowChildren); col.function?.(rowChildren)"
                                        class="w-6rem" inputStyleClass="w-full" size="small"
                                        [readonly]="col?.readonly == true" (pointerdown)="selectAll($event)" />
                                    <p-select [options]="listMoneda" [(ngModel)]="rowChildren[col.field.coin]"
                                        filter="true" appendTo="body" virtualScroll="true" virtualScrollItemSize="36"
                                        class="w-6rem"
                                        (onChange)="onChangeSelectCoin($event, rowChildren, listMoneda, col.field.coin); col.function?.(rowChildren)"
                                        size="small" [readonly]="col?.readonly == true" />
                                </ng-container>
                                <!-- FIN DROPDOWN -->
                                <ng-container *ngIf="col.type === 'unidad_valor'">
                                    <p-inputnumber [(ngModel)]="rowChildren[col.field.input]" mode="decimal"
                                        useGrouping="true" showButtons="false" minFractionDigits="2"
                                        (onBlur)="onChangeInput($event, rowChildren); col.function?.(rowChildren)"
                                        (keydown.enter)="onChangeInput($event, rowChildren); col.function?.(rowChildren)"
                                        class="w-6rem" inputStyleClass="w-full" size="small"
                                        [readonly]="col?.readonly == true" />
                                    <p-select [options]="listUnidad" [(ngModel)]="rowChildren[col.field.coin]"
                                        filter="true" appendTo="body" class="w-6rem"
                                        (onChange)="onChangeSelectCoin($event, rowChildren, listUnidad, col.field.coin); col.function?.(rowChildren)"
                                        size="small" [readonly]="col?.readonly == true" />
                                </ng-container>

                                <ng-container *ngIf="col.type === 'valor_unm'">
                                    <p-inputnumber [(ngModel)]="rowChildren[col.field.input]" mode="decimal"
                                        useGrouping="true" showButtons="false" minFractionDigits="2"
                                        (onBlur)="onChangeInput($event, rowChildren); col.function?.(rowChildren)"
                                        (keydown.enter)="onChangeInput($event, rowChildren); col.function?.(rowChildren)"
                                        class="w-6rem" inputStyleClass="w-full" size="small"
                                        [readonly]="col?.readonly == true" />
                                    <p-select [options]="listUnidadMedida" [(ngModel)]="rowChildren[col.field.coin]"
                                        filter="true" appendTo="body" class="w-6rem"
                                        (onChange)="onChangeSelectCoin($event, rowChildren, listUnidadMedida, col.field.coin); col.function?.(rowChildren)"
                                        size="small" [readonly]="col?.readonly == true" />
                                </ng-container>

                                <ng-container *ngIf="col.type === 'textArea'">
                                    <textarea [(ngModel)]="rowChildren[col.field.input]" [style.width]="col.maxWidth"
                                        rows="2" cols="15" [readonly]="col?.readonly == true" pTextarea pSize="small"
                                        required class="w-full"></textarea>
                                </ng-container>

                            </ng-template>

                            <!-- FIN MODO INPUT -->

                            <!-- MODO OUTPUT -->

                            <ng-template #output>
                                <div style="display: flex;flex-direction: row;justify-content: space-around;">
                                    <ng-container
                                        *ngIf="col.type !== 'moneda_monto' && col.type !== 'unidad_valor' && col.type !== 'valor_unm' && col.type !== 'textArea' && col.type !== 'date'">
                                        <!-- <div style="text-align: center;"> -->
                                        <div style="text-align: left;" class="body-table">{{
                                            rowChildren[col.field.output]
                                            }}
                                        </div>

                                        <!-- </div> -->
                                    </ng-container>

                                    <ng-container *ngIf="col.type === 'date'">
                                        <div style="text-align: left;" class="body-table">
                                            {{ rowChildren[col.field.output] ?
                                            util.formatearfecha(rowChildren[col.field.output],
                                            'dd/mm/yyyy') : null}}
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="col.type === 'moneda_monto'">
                                        <div style="text-align: center;" class="body-table">
                                            {{ rowChildren[col.field.output] }}
                                            {{ getMonedaLabel(rowChildren[col.field.coin]) }}
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="col.type === 'unidad_valor'">
                                        <div style="text-align: center;" class="body-table">
                                            {{ rowChildren[col.field.output] }}
                                            {{ getUnidadLabel(rowChildren[col.field.coin]) }}
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="col.type === 'valor_unm'">
                                        <div style="text-align: center;" class="body-table">
                                            {{ rowChildren[col.field.output] }}
                                            {{ getUnidadMedidaLabel(rowChildren[col.field.coin]) }}
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="col.type === 'textArea'">
                                        <div style="text-align: center;" class="body-table ellipsis">
                                            {{ rowChildren[col.field.output] }}
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="col?.buttonsBody">
                                        <p-button *ngFor="let item of col?.buttonsBody" [icon]="item.icon"
                                            [label]="item.label" [variant]="item.variant" [severity]="item.severity"
                                            (onClick)="item.functionRow({'father': rowData, 'children': rowChildren, 'event': $event}); $event.stopPropagation()"
                                            size="small" [pTooltip]="item.pTooltip"></p-button>
                                    </ng-container>
                                </div>
                            </ng-template>

                            <!-- FIN MODO OUTPUT -->

                        </p-cellEditor>


                    </td>

                </ng-container>
            </tr>


        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="6"></td>
            </tr>
        </ng-template>
    </p-table>
    <!-- #endregion -->
</div>
</td>
</tr>
</ng-template>

</p-table>
</div>